<script lang="ts">
  export let survey: string;
  import {DIV} from './utils';
  import {get, set} from 'idb-keyval';
  import AdminQuestionDisplay from './AdminQuestionDisplay.svelte';
  import {onMount} from 'svelte';

  let password = '';
  let results: {[key: string]: string | string[]}[] = [];
  let times: [number | undefined, number | undefined][] = [];
  let authed = false;
  let error = false;
  $: processedResults = results.reduce((acc, row) => {
    Object.entries(row).forEach(([key, val]) => {
      const [page, question] = key.split(DIV);
      if (!acc[page]) {
        acc[page] = {};
      }
      if (!acc[page][question]) {
        acc[page][question] = [];
      }
      acc[page][question].push(val);
    });
    return acc;
  }, {} as {[page: string]: {[question: string]: (string | string[])[]}});

  $: averageTime =
    times
      .filter(([x, y]) => x && y)
      .map((x) => x as [number, number])
      .map(([start, end]) => (end - start) / (1000 * 60))
      .reduce((acc, row) => acc + row, 0) / times.length;

  function tryAuth() {
    set(`admin-password-attempt-${survey}`, password);
    fetch('/.netlify/functions/admin', {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({survey, password})
    }).then((x) => {
      if (!x.ok) {
        error = true;
        return;
      }
      return x.json().then((x) => {
        authed = true;
        results = x.results;
        times = x.times;
      });
    });
  }
  onMount(async () => {
    const savedPassword = await get(`admin-password-attempt-${survey}`);
    if (savedPassword) {
      password = savedPassword;
      tryAuth();
    }
  });
</script>

<main class="h-full w-full">
  <div class="bg-black text-white text-2xl text-center p-2">Results Page for {survey}</div>
  {#if !authed}
    <div class="flex justify-center items-center h-full w-full">
      <form class="flex flex-col" on:submit|preventDefault={() => tryAuth()}>
        {#if !authed && error}
          <h1 class="text-red-400">bad password</h1>
        {/if}
        <input
          class="border-2"
          on:change={(e) => {
            password = e.target.value;
          }}
          value={password}
        />
        <button>Submit</button>
      </form>
    </div>
  {:else}
    <div class="flex flex-col h-full w-full items-center w-3xl">
      <div class="border-2">
        <div class="w-full bg-black text-white px-4 py-2">
          <h3 class="text-xl">Top level stats</h3>
        </div>
        <div class="p-4 max-w-3xl w-3xl">
          <h3>Number of responses: {results.length}</h3>
          <h3>Average time: {averageTime} minutes</h3>
        </div>
      </div>
      <div>
        {#each Object.entries(processedResults) as [page, questions]}
          <div class="border-2">
            <div class="w-full bg-black text-white px-4 py-2">
              <h3 class="text-xl">Page: {page}</h3>
            </div>
            <div class="p-4">
              {#each Object.entries(questions) as [question, responses]}
                <AdminQuestionDisplay {question} {responses} />
              {/each}
            </div>
          </div>
        {/each}
      </div>
    </div>
  {/if}
</main>
